module.exports = __webpack_public_path__ + "static/img/v2_qnqlkb.cf89d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/v2_qnqlkb.png
// module id = iBd3
// module chunks = 1